type FontWeightConstant = 300 | 400 | 500 | 600 | 700;

export const fontWeightLight: FontWeightConstant = 300;
export const fontWeightRegular: FontWeightConstant = 400;
export const fontWeightMedium: FontWeightConstant = 500;
export const fontWeightMediumLarge: FontWeightConstant = 600;
export const fontWeightBold: FontWeightConstant = 700;
